import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { map } from 'lodash/fp';
import moment from 'moment';
import classnames from 'classnames';
import { useAppointmentStore } from 'store/mobx/mobx';

import { actions as appointmentActions } from '../../../BookingPageMobile/actions/actions';
import { actions as filterActions } from '../../../BookingPageMobile/actions/filterActions';
import { actions as multiDayActions } from '../../../actions/appointmentActions';
import { actions as patientActions } from 'vAppointment/PatientDetails/actions/actions';
import { actions as guardianActions } from 'vAppointment/PatientDetails/actions/guardianActions';
import { actions as patientSelectionActions } from 'vAppointment/PatientSelection/actions/actions';
import DaySelector from './DaySelector/index';
import NotOnline from '../../NotOnline/index';
import NotFound from '../../NotFound/index';
import FilterBox from './FilterBox/index';
import DoctorMainComponent from './DoctorMainComponent';
import DoctorLoadSpinner from './DoctorLoadSpinner/index';
import {
  practiceProfilePropType,
  doctorProfilePropType,
} from '../../../propTypes/index';
import styles from './desktopAppointments.module.css';
import {
  filterDoctors,
  filterDoctorsByService,
  matchAppointments,
  contains,
} from './filterFunctions';
import { go } from '../../../../routes';
import LoginFirst from 'PracticeProfilePage/components/LoginFirst';

export class DesktopAppointments extends Component {
  static propTypes = {
    getMultiDayAppointments: PropTypes.func.isRequired,
    getMultiDayAppointmentsForPatient: PropTypes.func.isRequired,
    currentFilter: PropTypes.string.isRequired,
    filterMorning: PropTypes.func.isRequired,
    filterAfternoon: PropTypes.func.isRequired,
    filterEvening: PropTypes.func.isRequired,
    selectTime: PropTypes.func.isRequired,
    selectedDay: PropTypes.instanceOf(Date).isRequired,
    doctors: PropTypes.arrayOf(doctorProfilePropType).isRequired,
    appointments: PropTypes.arrayOf(doctorProfilePropType).isRequired,
    practice: practiceProfilePropType.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isFetchingPractice: PropTypes.bool.isRequired,
    maxDays: PropTypes.number.isRequired,
    token: PropTypes.string,
    onTimeSelectedFn: PropTypes.func,
    id: PropTypes.string.isRequired,
    patientDetails: PropTypes.object,
    guardianDetails: PropTypes.object,
    fetchError: PropTypes.any,
    clearPatient: PropTypes.func,
    clearGuardian: PropTypes.func,
    fillSession: PropTypes.func,
    clearFetchMultiDayAppointments: PropTypes.func,
    apptStore: PropTypes.object,
  };
  state = {
    mainDay: moment(),
    filterStr: '',
    filteredDoctors: this.props.doctors,
    serviceFilterStr: '',
    test: '',
    shouldFix: false,
    selectedDoctor: null,
    error: null,
    selectedService: null,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.getAppointments(moment(), 'flu');
    const urlParams = new URLSearchParams(window.location.search);
    const serviceParam = parseInt(urlParams.get('service'), 10);
    const providerParam = urlParams.get('provider');
    if (serviceParam) {
      const selectedService = this.props.practice.Services.find(
        service => service.Id === serviceParam,
      );
      if (selectedService) {
        this.props.apptStore.setSelectedService(selectedService);
        this.setState({ selectedService });
      }
    }
    if (providerParam) {
      this.setState({ filterStr: providerParam });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.doctors !== this.props.doctors) {
      this.displayDoctors(nextProps.doctors);
    }
    if (nextProps.fetchError && !this.state.error) {
      this.setState({ error: nextProps.fetchError });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.patientDetails.ready && !prevProps.patientDetails.ready) {
      this.getAppointments(moment(), 'flu');
    }
    if (
      this.props.doctors !== prevProps.doctors &&
      this.state.selectedService
    ) {
      this.filterDoctorsByNameAndService(
        filterDoctors(this.state.filterStr),
        filterDoctorsByService,
        this.state.filterStr,
        this.state.selectedService?.Id,
      );
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) return true;
    else if (nextProps.currentFilter !== this.props.currentFilter) return true;
    else if (
      nextProps.patientDetails?.patientDetails?.firstName !==
      this.props.patientDetails?.patientDetails?.firstName
    )
      return true;
    else if (nextProps.currentServiceFilter !== this.props.currentServiceFilter)
      return true;
    else if (nextProps.isFetching !== this.props.isFetching) return true;
    else if (
      nextProps.patientDetails?.ready !== this.props.patientDetails?.ready
    )
      return true;
    else if (nextProps.doctors !== this.props.doctors) return true;
    return false;
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  getAppointments = (startDay, doctorName) => {
    if (this.props.practice.MustLoginBeforeBooking) {
      if (this.props.patientDetails.ready) {
        this.props.getMultiDayAppointmentsForPatient(
          this.props.id,
          {
            FirstName: this.props.patientDetails.patientDetails.firstName,
            LastName: this.props.patientDetails.patientDetails.lastName,
            DateOfBirth: this.props.patientDetails.patientDetails.dateOfBirth,
            Mobile: this.props.patientDetails.patientDetails.mobile,
            DependantId: this.props.patientDetails.patientDetails.dependantId,
            InitiatorFirstName: this.props.guardianDetails.firstName,
            InitiatorLastName: this.props.guardianDetails.lastName,
            InitiatorDateOfBirth: this.props.guardianDetails.dateOfBirth,
            InitiatorMobile: this.props.guardianDetails.mobile,
          },
          moment(startDay),
          5,
          doctorName,
          this.props.token,
        );
      }
    } else {
      this.props.getMultiDayAppointments(
        this.props.id,
        moment(startDay),
        5,
        doctorName,
      );
    }
  };
  setMainDay = day => {
    this.setState({ mainDay: day });
    this.props.selectDay(
      this.props.practice.UrlName,
      day.toDate(),
      'first',
      'flu',
    );
    this.getAppointments(day, 'flu');
  };
  setTime = (doctorId, appointmentId, time, sessionId) => {
    this.props.selectTime(doctorId, appointmentId, time);
    if (!this.props.practice.MustLoginBeforeBooking) {
      if (this.props.onTimeSelectedFn) {
        this.props.onTimeSelectedFn(doctorId, appointmentId, time);
      } else if (this.props.token) {
        go.patientSelection(this.props.practice.UrlName);
      } else {
        go.loginTriage(this.props.practice.UrlName);
      }
    } else {
      if (this.props.onTimeSelectedFn) {
        this.props.onTimeSelectedFn(doctorId, appointmentId, time);
      } else {
        this.props.fillSession(
          this.props.practice.UrlName,
          this.props.practice.Id,
          sessionId,
          doctorId,
          appointmentId,
          time,
        );
        go.reason(this.props.practice.UrlName, true);
      }
    }
  };
  toggleDoctor = doctor => {
    if (doctor) go.doctorProfile(this.props.id, doctor);
    else go.practiceProfile(this.props.id);
  };
  filterToDate = date => {
    const hourOfDay = moment(date).hour();
    if (hourOfDay < 12) {
      this.props.filterMorning();
    } else if (hourOfDay < 17) {
      this.props.filterAfternoon();
    } else {
      this.props.filterEvening();
    }
    this.setMainDay(moment(date));
  };
  moveDays = direction => {
    if (direction === 'forward') {
      this.setState({ mainDay: this.state.mainDay.add(5, 'days') });
    }
    if (direction === 'back') {
      this.setState({ mainDay: this.state.mainDay.subtract(5, 'days') });
    }
    this.getAppointments(this.state.mainDay, 'flu');
  };

  filterDoctorsByNameAndService = (
    nameFilterFn,
    serviceFilterFn,
    filterStr,
    serviceId,
  ) => {
    this.setState({ filterStr });

    const selectedService = this.props.practice.Services.find(
      service => service.Id === serviceId,
    );
    this.props.apptStore.setSelectedService(selectedService);
    this.setState({ selectedService });

    let nameFilteredDoctors = nameFilterFn(
      this.props.doctors,
      this.state.selectedDoctor,
    );
    if (filterStr.length <= 0) {
      nameFilteredDoctors = this.sortDoctors(this.props.doctors);
    } else {
      nameFilteredDoctors = this.sortDoctors(nameFilteredDoctors);
    }

    let filteredDoctors = nameFilteredDoctors;
    if (nameFilteredDoctors?.length > 0) {
      filteredDoctors = serviceFilterFn(nameFilteredDoctors, serviceId);
      if (!serviceId) {
        filteredDoctors = this.sortDoctors(nameFilteredDoctors);
      } else {
        filteredDoctors = this.sortDoctors(filteredDoctors);
      }
    }

    this.displayDoctors(filteredDoctors);
  };

  filterDoctors = filterStr => {
    this.setState({ filterStr }, () =>
      this.filterDoctorsByNameAndService(
        filterDoctors(this.state.filterStr),
        filterDoctorsByService,
        this.state.filterStr,
        this.state.selectedService?.Id,
      ),
    );
  };

  filterDoctorByService = serviceId => {
    const selectedService = this.props.practice.Services.find(
      service => service.Id === serviceId,
    );
    this.props.apptStore.setSelectedService(selectedService);

    this.setState({ selectedService }, () =>
      this.filterDoctorsByNameAndService(
        filterDoctors(this.state.filterStr),
        filterDoctorsByService,
        this.state.filterStr,
        this.state.selectedService?.Id,
      ),
    );
  };

  displayDoctors = doctors => {
    let filteredDoctors = this.sortDoctors(doctors);
    this.setState({ filteredDoctors });
  };

  sortDoctors(doctors) {
    if (!this.state.selectedDoctor) return doctors;
    return doctors.reduce((acc, doc) => {
      if (contains(doc.Name, this.state.selectedDoctor)) {
        return [doc, ...acc];
      }
      return [...acc, doc];
    }, []);
  }
  handleScroll = () => {
    if (this.filters) {
      if (
        this.state.shouldFix &&
        this.filters.getBoundingClientRect().top >= 1
      ) {
        this.setState({ shouldFix: false });
      } else if (this.filters.getBoundingClientRect().top < 1) {
        this.setState({ shouldFix: true });
      }
    }
  };
  addSelect = filter => {
    this.setState({ selectedDoctor: filter }, () =>
      this.filterDoctors(
        filterDoctors(this.state.filterStr),
        this.state.filterStr,
      ),
    );
  };
  clearSelect = () => {
    this.setState({ selectedDoctor: null }, () =>
      this.filterDoctors(filterDoctors(''), ''),
    );
  };
  clearIdentifiedPatient = () => {
    this.props.clearPatient();
    this.props.clearGuardian();
    this.props.clearFetchMultiDayAppointments();
    this.setState({ error: null });
  };
  render() {
    const shouldFix = this.state.shouldFix;
    return (
      <div className={styles.container} ref={this.props.innerRef}>
        <div
          ref={c => {
            this.filters = c;
          }}
          className={classnames({ [styles.filterBox]: shouldFix })}
        >
          <div className={classnames({ [styles.fixed]: shouldFix })}>
            <FilterBox
              currentFilter={this.state.filterStr}
              filterDoctorsByService={this.filterDoctorByService}
              filterMorning={this.props.filterMorning}
              filterAfternoon={this.props.filterAfternoon}
              filterEvening={this.props.filterEvening}
              selectedDay={this.props.selectedDay}
              setMainDay={this.setMainDay}
              maxDays={this.props.maxDays}
              filterDoctors={this.filterDoctors}
              services={this.props.practice.Services}
              selectedService={this.state.selectedService}
            />
            {this.props.practice.IsOnline ? (
              <DaySelector
                selectedDoctor={this.state.selectedDoctor}
                onClickLeft={() => this.moveDays('back')}
                onClickRight={() => this.moveDays('forward')}
                mainDay={this.state.mainDay}
                clearSelect={this.clearSelect}
                showChangePatient={
                  this.props.practice.MustLoginBeforeBooking &&
                  this.props.patientDetails.ready
                }
                patientChanged={() => {
                  this.clearIdentifiedPatient();
                  if (this.props.token) {
                    go.selection(this.props.practice.UrlName);
                  } else {
                    go.welcome(this.props.practice.UrlName);
                  }
                }}
              />
            ) : null}
          </div>
        </div>
        <div>
          {(() => {
            if (
              this.props.practice.MustLoginBeforeBooking &&
              !this.props.patientDetails.ready
            ) {
              return <LoginFirst clinic={this.props.practice} />;
            } else if (
              (this.props.isFetching || this.props.isFetchingPractice) &&
              this.state.filteredDoctors.length === 0
            ) {
              return <DoctorLoadSpinner />;
            } else if (
              !this.props.isFetchingPractice &&
              !this.props.isFetching &&
              this.state.filteredDoctors.length === 0
            ) {
              return (
                <NotOnline
                  isOffline={!this.props.practice.IsOnline}
                  noDoctors={
                    this.state.filteredDoctors.length === 0 && !this.state.error
                  }
                  error={this.state.error}
                  clearState={this.clearIdentifiedPatient}
                />
              );
            } else {
              return (
                <div>
                  <NotFound
                    doctors={this.state.filteredDoctors}
                    searchTerm={this.state.selectedDoctor}
                    filter={this.state.filterStr}
                  />
                  {map(d => (
                    <DoctorMainComponent
                      key={d.PmsUserId}
                      isFetching={this.props.isFetching}
                      doctor={d}
                      appointments={matchAppointments(
                        d.PmsUserId,
                        this.props.appointments,
                      )}
                      toggleDoctorProfile={this.toggleDoctor}
                      setTime={this.setTime}
                      filterToDate={this.filterToDate}
                      currentFilter={this.props.currentFilter}
                      filterMorning={this.props.filterMorning}
                      filterAfternoon={this.props.filterAfternoon}
                      filterEvening={this.props.filterEvening}
                    />
                  ))(this.state.filteredDoctors)}
                </div>
              );
            }
          })()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetchingPractice: state.practiceProfileReducer.isFetching,
  isFetching: state.multiDayAppointmentsReducer.isFetching,
  token: state.loginReducer.token,
  onTimeSelectedFn: state.practiceBookingPageReducer.onTimeSelectedFn,
  selectedDay: state.practiceAppointmentReducer.selectedDay,
  maxDays: state.practiceProfileReducer.profile.MaxDays || 0,
  doctors: state.multiDayAppointmentsReducer.doctorInfo.doctors,
  fetchError: state.multiDayAppointmentsReducer.error,
  appointments: state.multiDayAppointmentsReducer.doctors,
  currentFilter: state.multiDayAppointmentsReducer.currentFilter,
  patientDetails: state.patientDetailsReducer,
  guardianDetails: state.guardianDetailsReducer,
});
const mapDispatchToProps = dispatch => ({
  selectTime: bindActionCreators(appointmentActions.selectTime, dispatch),
  selectDay: bindActionCreators(appointmentActions.selectDay, dispatch),
  getMultiDayAppointments: bindActionCreators(
    multiDayActions.fetchMultiDayAppointments,
    dispatch,
  ),
  getMultiDayAppointmentsForPatient: bindActionCreators(
    multiDayActions.fetchMultiDayAppointmentsForPatient,
    dispatch,
  ),
  filterMorning: bindActionCreators(filterActions.filterMorning, dispatch),
  filterAfternoon: bindActionCreators(filterActions.filterAfternoon, dispatch),
  filterEvening: bindActionCreators(filterActions.filterEvening, dispatch),
  clearPatient: bindActionCreators(patientActions.clearDetails, dispatch),
  clearGuardian: bindActionCreators(guardianActions.clearState, dispatch),
  clearFetchMultiDayAppointments: bindActionCreators(
    multiDayActions.clearFetchMultiDayAppointmentsStatus,
    dispatch,
  ),
  fillSession: bindActionCreators(
    patientSelectionActions.fillSession,
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DesktopAppointments);
